"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_native_1 = require("react-native");
exports.styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        height: react_native_1.Platform.OS === 'web' ? '100vh' : '100%',
        marginHorizontal: 'auto',
        marginVertical: 20,
        width: 1080,
    },
    heading2: {
        fontSize: 24,
        fontWeight: 'bold',
        marginVertical: 20,
        color: '#000',
    },
    heading3: {
        fontSize: 20,
        fontWeight: 'bold',
        marginVertical: 20,
        color: '#000',
    },
    saveMessageContainer: {
        marginHorizontal: 'auto',
        position: 'relative',
        minWidth: 160,
    },
    saveMessageText: {
        color: '#3db384',
        position: 'absolute',
        left: 0,
        right: 0,
    },
    buttonContainer: {
        justifyContent: 'center',
        marginVertical: 30,
    },
    button: {
        backgroundColor: '#3db384',
        borderRadius: 24,
        paddingHorizontal: 50,
        paddingVertical: 10,
    },
    buttonLoading: {
        backgroundColor: 'rgba(61, 179, 132, .5)',
        borderRadius: 24,
        paddingHorizontal: 50,
        paddingVertical: 10,
    },
    buttonText: {
        color: '#fff',
    },
    backButtonText: {
        color: '#3db384',
    },
    errorText: {
        position: 'absolute',
        color: '#ff0000',
        bottom: -25,
    },
    errorTextAddress: {
        position: 'absolute',
        color: '#ff0000',
        bottom: -39,
    },
    errorTextBottom25: {
        bottom: 25,
    },
    lastError: {
        width: '100%',
        justifyContent: 'center',
    },
    picker: {
        width: '100%',
        paddingVertical: 10,
        paddingHorizontal: 12,
        marginTop: 15,
    },
    input: {
        marginRight: 0,
        width: react_native_1.Platform.OS !== 'web' ? '100%' : undefined,
    },
    label: {
        marginBottom: 10,
    },
    introText: {
        marginBottom: 20,
    },
});
